// extracted by mini-css-extract-plugin
export default {"fancyMarket__sections":"styles_fancyMarket__sections__56n6k"};